import React from 'react';

import { getCsrfToken } from '../helpers/GetCsrfToken';

const braintree = require('braintree-web');

export default class PayByCard extends React.Component {
  constructor(props) {
    super(props);
    this.vaultCheckbox = React.createRef();

    this.state = {
      hostedFieldsInstance: null,
      fields: {},
      formValid: false,
      vaultCheckboxTicked: false,
      emailAddress:
        !!this.props.customer &&
          !!this.props.customer.id &&
          !!this.props.customer.emailAddress
          ? this.props.customer.emailAddress
          : '',
      emailAddressProps: {
        isInvalid: false,
        isEmpty: false
      },
      displayInvalidFields: {
        email: false,
        creditCard: false,
        cvv: false,
        expiry: false
      }
    };
  }

  componentWillUnmount() {
    this.props.submitPaymentCancel();
  }

  checkEmailValidity() {
    const emailAddress = this.state.emailAddress;
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailAddress === '') {
      const emailAddressProps = {
        isInvalid: false,
        isEmpty: true
      };
      this.setState(
        {
          emailAddressProps
        }
      );
      return emailAddressProps;
    } else if (re.test(emailAddress) === false) {
      const emailAddressProps = {
        isInvalid: true,
        isEmpty: false
      };
      this.setState(
        {
          emailAddressProps
        }
      );
      return emailAddressProps;
    } else {
      var displayInvalidFields = this.state.displayInvalidFields;
      displayInvalidFields.email = false;
      const emailAddressProps = {
        isInvalid: false,
        isEmpty: false
      }
      this.setState(
        {
          emailAddressProps,
          displayInvalidFields
        }
      );
      return emailAddressProps;
    }
  }

  async postPayment(payload, hostedFieldsInstance) {
    var storeInVault = false;
    if (!!this.props.customer && !!this.props.customer.id) {
      if (!!this.vaultCheckbox && this.vaultCheckbox.current.checked === true) storeInVault = true;
    }

    const response = await fetch(`api/Braintree/Pay`, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-XSRF-TOKEN': getCsrfToken()
      },
      body: this.props.generatePaymentBody(
        payload,
        this.state.emailAddress,
        storeInVault
      )
    });

    let data;
    try {
      data = await response.json()
    } catch (err) {
      console.error(err);
      this.props.submitPaymentFail();
      return;
    }
    if (data.success === false) {
      this.props.submitPaymentFail(data.reason);
      return;
    }

    hostedFieldsInstance.teardown(function (teardownErr) {
      if (teardownErr) console.error('Could not tear down the Hosted Fields form!');
    });
    this.props.storeCustomerEmail(this.state.emailAddress);
    this.props.paymentSuccessful(data);

    if (!!data.vaultId) {
      this.props.storeVaultId(data.vaultId);
    }
  }

  checkFormValidity(event) {
    var formValid = Object.keys(event.fields).every(key => {
      return event.fields[key].isValid;
    });

    let displayInvalidFields = this.state.displayInvalidFields;
    if (event.fields.number.isValid === true)
      displayInvalidFields.creditCard = false;
    if (event.fields.cvv.isValid === true) displayInvalidFields.cvv = false;
    if (event.fields.expirationDate.isValid === true)
      displayInvalidFields.expiry = false;

    this.setState({ fields: event.fields, displayInvalidFields, formValid });
  }

  submitPayment(event) {
    this.setState({ fields: event.fields });
    if (this.props.submittingPayment === false) {

      const emailProps = this.checkEmailValidity();
      if (emailProps.isInvalid === true || emailProps.isEmpty === true) {
        let displayInvalidFields = this.state.displayInvalidFields;
        displayInvalidFields.email = true;
        this.setState({
          displayInvalidFields
        });
      }
      
      const hostedFieldsInstance = this.state.hostedFieldsInstance;
      if (
        this.state.formValid === true &&
        emailProps.isInvalid === false &&
        emailProps.isEmpty === false
      ) {
        this.props.submitPayment();
        hostedFieldsInstance.tokenize({}, async (err, payload) => {
          if (err) {
            console.error(err);
            return;
          }
          var threeDSecureParameters = {
            amount: this.props.grandTotal,
            nonce: payload.nonce,
            bin: payload.details.bin,
            email: this.props.customer
              ? this.props.customer.emailAddress
              : this.state.email,
            onLookupComplete: (data, next) => {
              // use `data` here, then call `next()`
              next();
            }
          };

          try {

            let threeDSecure;

            const clientInstance = await braintree.client.create({
              authorization: this.props.clientToken
            });

            const threeDSecureInstance = await braintree.threeDSecure.create({
              version: '2', // Will use 3DS 2 whenever possible
              client: clientInstance
            });

            threeDSecure = threeDSecureInstance;
            const payByCardContainer = document.getElementById(
              'pay-by-card-container'
            );

            threeDSecure.on(
              'authentication-iframe-available',
              (event, next) => {
                this.props.pausePaymentLoadingAnimation();
                payByCardContainer.appendChild(event.element);
                event.element.className = 'three-d-secure-container';
                next();
              }
            );

            try {
              let response = await threeDSecure
                .verifyCard(threeDSecureParameters)

              this.props.unpausePaymentLoadingAnimation();
              threeDSecure.teardown();
              var threeDSecureElem = document.getElementsByClassName(
                'three-d-secure-container'
              )[0];
              if (!!threeDSecureElem) {
                payByCardContainer.removeChild(threeDSecureElem);
              }
              this.postPayment(response, hostedFieldsInstance);
            } catch (error) {
              console.log(error);
              this.props.unpausePaymentLoadingAnimation();
              threeDSecure.teardown();
              var threeDSecureElem = document.getElementsByClassName(
                'three-d-secure-container'
              )[0];
              if (!!threeDSecureElem) {
                payByCardContainer.removeChild(threeDSecureElem);
              }
              this.props.submitPaymentFail();
              // Handle error
            };
          } catch (err) {
            console.log(err);
            this.props.submitPaymentFail();
            // Handle component creation error
          };
        });
      } else {
        let displayInvalidFields = this.state.displayInvalidFields;
        if (
          event.fields.number.isValid === false ||
          event.fields.number.isEmpty === true
        )
          displayInvalidFields.creditCard = true;
        if (
          event.fields.cvv.isValid === false ||
          event.fields.cvv.isEmpty === true
        )
          displayInvalidFields.cvv = true;
        if (
          event.fields.expirationDate.isValid === false ||
          event.fields.expirationDate.isEmpty === true
        )
          displayInvalidFields.expiry = true;

        this.setState({ fields: event.fields, displayInvalidFields });
      }

    }
  }

  async componentDidMount() {
    if (this.state.hostedFieldsInstance !== null) return;

    braintree.client
      .create({
        authorization: this.props.clientToken
      })
      .then(clientInstance => {
        var options = {
          client: clientInstance,
          styles: {
            input: {
              'font-family': 'DMSans-Regular, sans-serif',
              'font-size': '1.5rem',
              'line-height': '1.35rem',
              color: 'rgb(8, 16, 32)',
              padding: '1rem 0.625rem',
              'background-color': '#ffffff',
              'max-width': '500px',
              'border-radius': '20px'
            },
            'input#credit-card-number': {},
            'input#cvv': {},
            'input#expiration': {},
            '.valid': {
              color: '#008041'
            },
            '#card-number input::-ms-input-placeholder': {
              color: 'pink'
            },
            '#card-number input:-ms-input-placeholder': {
              color: 'pink'
            },
            '#card-number input::-moz-placeholder': {
              color: 'pink'
            },
            '#card-number input:-moz-placeholder': {
              color: 'pink'
            },
            '#card-number input::-webkit-input-placeholder': {
              color: 'pink'
            },
            '#card-number input:placeholder-shown': {
              color: 'pink'
            },
            '#card-number input::placeholder': {
              color: 'pink'
            }
          },
          fields: {
            number: {
              container: '#card-number',
              placeholder: '4111 1111 1111 1111'
            },
            cvv: {
              container: '#cvv',
              placeholder: '987'
            },
            expirationDate: {
              container: '#expiration-date',
              placeholder: '01 / 23'
            }
          }
        };
        return braintree.hostedFields.create(options);
      })
      .then(hostedFieldsInstance => {
        this.setState({ fields: hostedFieldsInstance.getState() });
        this.props.setMainCTA(() => this.submitPayment(this.state.hostedFieldsInstance.getState()));
        this.props.finishedPaymentLoadingAnimation();

        hostedFieldsInstance.on('inputSubmitRequest', event => {
          this.submitPayment(event);
        });
        hostedFieldsInstance.on('validityChange', event => {
          this.checkFormValidity(event);
        });
        hostedFieldsInstance.on('focus', event => {
          let container = event.fields[event.emittedBy].container;
          container.scrollIntoView({
            block: 'center',
            inline: 'nearest'
          });
        });

        this.setState({
          hostedFieldsInstance
        });
      })
      .catch(function (err) {
        console.log('Error.', err);
      });
  }

  handleEmailChange(e) {
    const emailAddress = e.target.value.trim();
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let emailAddressProps = this.state.emailAddressProps;
    let displayInvalidFields = this.state.displayInvalidFields;
    if (re.test(emailAddress) === true) {
      emailAddressProps.isInvalid = false;
      emailAddressProps.isEmpty = false;
      displayInvalidFields.email = false;
    }
    this.setState({
      emailAddress: e.target.value.trim(),
      emailAddressProps,
      displayInvalidFields
    });
  }

  handleEmailKeyPress(e) {
    if (e.key === 'Enter') {
      this.submitPayment(this.state.hostedFieldsInstance.getState());
    }
  }

  handleFocus = e => {
    var element = e.target;
    element.scrollIntoView({
      block: 'center',
      inline: 'nearest'
    });
  };

  render() {
    return (
      <div id="pay-by-card-container">
        <div
          id="pay-form"
          className="pay-by-card"
          style={
            this.props.paymentLoadingAnimation === true ||
              this.props.submittingPayment === true
              ? { display: 'none' }
              : {}
          }
        >
          {(!this.props.customer ||
            !this.props.customer.emailAddress ||
            !this.props.customer.token) && (
              <div>
                <label htmlFor="email-address">Email address</label>
                <div className="payment-method-info" id="email-address">
                  <input
                    type="email"
                    placeholder="customer@pizzaexpress.com"
                    onChange={e => this.handleEmailChange(e)}
                    onKeyDown={e => this.handleEmailKeyPress(e)}
                    onFocus={e => this.handleFocus(e)}
                    defaultValue={
                      !!this.props.socialCustomer
                        ? this.props.socialCustomer.emailAddress
                        : ''
                    }
                    maxLength="100"
                    name="email"
                    autoComplete="on"
                  ></input>
                </div>
                {this.state.displayInvalidFields.email === true &&
                  this.state.emailAddressProps.isEmpty === true && (
                    <p className="warning">Email address required</p>
                  )}
                {this.state.displayInvalidFields.email === true &&
                  this.state.emailAddressProps.isEmpty === false &&
                  this.state.emailAddressProps.isInvalid === true && (
                    <p className="warning">Email not valid</p>
                  )}
              </div>
            )}

          <label htmlFor="card-number">Card Number</label>
          <div className="payment-method-info" id="card-number"  name="cardnumber" autoComplete="on">
          </div>

          {this.state.displayInvalidFields.creditCard === true &&
            !!this.state.fields.number &&
            this.state.fields.number.isValid === false &&
            this.state.fields.number.isEmpty === false && (
              <p className="warning">Card number not valid</p>
            )}
          {this.state.displayInvalidFields.creditCard === true &&
            !!this.state.fields.number &&
            this.state.fields.number.isEmpty === true && (
              <p className="warning">Card number required</p>
            )}

          <label htmlFor="cvv">CVV</label>
          <div className="payment-method-info" id="cvv" placeholder="234" autoComplete="on"></div>

          {this.state.displayInvalidFields.cvv === true &&
            !!this.state.fields.cvv &&
            this.state.fields.cvv.isValid === false &&
            this.state.fields.cvv.isEmpty === false && (
              <p className="warning">CVV not valid</p>
            )}
          {this.state.displayInvalidFields.cvv === true &&
            !!this.state.fields.cvv &&
            this.state.fields.cvv.isEmpty === true && (
              <p className="warning">CVV required</p>
            )}

          <label htmlFor="expiration-date">Expiration Date</label>
          <div
            className="payment-method-info"
            id="expiration-date"
            placeholder="0119"
            autoComplete="on"
          ></div>

          {this.state.displayInvalidFields.expiry === true &&
            !!this.state.fields.expirationDate &&
            this.state.fields.expirationDate.isValid === false &&
            this.state.fields.expirationDate.isEmpty === false && (
              <p className="warning">Expiration date not valid</p>
            )}
          {this.state.displayInvalidFields.expiry === true &&
            !!this.state.fields.expirationDate &&
            this.state.fields.expirationDate.isEmpty === true && (
              <p className="warning">Expiration date required</p>
            )}
          {!!this.props.customer && !!this.props.customer.id ? (
            <div className="checkbox-container">
              <div className="checkbox-wrapper">
                <input
                  type="checkbox"
                  id="vault-checkbox"
                  ref={this.vaultCheckbox}
                />
                <span className="tick"></span>
              </div>
              <label className="save-card-label" htmlFor="vault-checkbox">
                Save card details for future payments
              </label>
            </div>
          ) : null}
          {/* Pretty sure this "pay-button" div is defunct now */}
          <div id="pay-button"></div>
        </div>
      </div>
    );
  }
}
